import script from "./SupportForm.vue?vue&type=script&setup=true&lang=js"
export * from "./SupportForm.vue?vue&type=script&setup=true&lang=js"

import "./SupportForm.vue?vue&type=style&index=0&id=492f850c&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-492f850c"]])

export default __exports__